import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { GlgTooltipIcon } from 'SharedComponents'

export class ActionsPanel extends Component {
  constructor(props) {
    super(props)
    this.deleteMember = this.deleteMember.bind(this)
    this.editMember = this.editMember.bind(this)
    this.registerMember = this.registerMember.bind(this)
    this.resetPassword = this.resetPassword.bind(this)
  }
  
  deleteMember() {
    let confirmMessage
    let noSync = false
    if (this.props.hasMrSyncEnabled) {
      if (this.props.member.status !== 'member_deleted') {
        confirmMessage = !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.mr_sync_integration_note', window.participantFormats)
        noSync = true
      }
    } else {
      if (this.props.member.status === 'self_registered_members') {
        confirmMessage = !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.self_registered_members', { name: this.props.member.full_name })
      } else if (this.props.customerSoftDelete) {
        confirmMessage = !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.customer_soft_delete', { name: this.props.member.full_name })
      } else {
        if (this.props.member.status !== 'member_deleted') {
          confirmMessage = !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.member_deleted', { name: this.props.member.full_name })
        }
      }
    }
    if (confirmMessage) {
      // eslint-disable-next-line no-alert
      if (window.confirm(confirmMessage)) {
        this.props.deleteMember(this.props.member.id, 'delete', noSync)
      }
    } else {
      this.props.deleteMember(this.props.member.id, 'undelete')
    }
  }
  
  registerMember(type) {
    if (type === 'unregister') {
      this.props.unregisterMember(this.props.member.id)
    } else {
      this.props.openRegisterMemberPopup(this.props.member.id)
      this.props.getRegisterMemberData(this.props.member.id)
    }
  }
  
  editMember(){
    this.props.openEditMemberModal(this.props.member.id)
  }
  
  resetPassword(){
    // eslint-disable-next-line no-alert
    if (window.confirm(!window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.send_reset_passwd_email'))) {
      this.props.resetPasswordMember(this.props.member.id, this.props.member.email)
    }
  }

  render() {
    let inviteLabel
    let tooltip = !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.members_access_private_pages', { product: this.props.leagueProduct, ...window.participantFormats })
    let type = 'register'
    if (this.props.member.glg_status === (!window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.not_registered'))) {
      inviteLabel = !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.register')
    } else if ([ !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.email_bounced_registered'), !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.registered_not_confirmed') ].indexOf(this.props.member.glg_status) > -1) {
      inviteLabel = !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.reregister')
    } else if (this.props.member.glg_status === (!window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.registered'))) {
      inviteLabel = !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.unregister')
      type = 'unregister'
      tooltip = ''
    }

    return <div className="panel panel-default dropdown-menu glg-react-dropdown-menu"><div style={{padding: 0}} className="panel-body"><div style={{fontSize: '11px', borderBottom: '1px solid #D8D8D8', margin: '0 5px 5px 5px'}} className="action-item"><i className="gga-user"></i><i>{this.props.member.full_name}</i></div><div className="action-item"><a href="#" onClick={this.editMember}><i className="gga-pencil-45-angle"></i><span>{ !window.I18n ? '' : window.I18n.t('buttons.edit') }</span></a></div>{ this.props.member.status === 'self_registered_members' && <div className="action-item"><a href="#" onClick={() => this.props.confirmMember(this.props.member.id)}><i className="gga-confirm"></i><span>{ !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.confirm') }</span><GlgTooltipIcon tooltip={ !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.confirm_golfer', window.participantFormats) }></GlgTooltipIcon></a></div> }{ inviteLabel && this.props.canUseMasterRosterRegistration && <div className="action-item"><a href="#" onClick={() => this.registerMember(type)}><i className="gga-table-register-member"></i><span>{ inviteLabel }</span>{tooltip && <GlgTooltipIcon tooltip={tooltip} placement={'top'}></GlgTooltipIcon>}</a></div>}{ (this.props.member.email && this.props.member.glg_status === (!window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.registered'))) && <div className="action-item"><a href="#" onClick={this.resetPassword}><i className="gga-arrow-round-left"></i><span>{ !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.reset_password') }</span><GlgTooltipIcon tooltip={ !window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.send_instructions_email', { email: this.props.member.email }) }></GlgTooltipIcon></a></div> }{ !this.props.isTourManager && <div className="action-item"><a href="#" onClick={ this.deleteMember }><i className="gga-table-delete-member"></i><span>{ this.props.member.status === 'member_deleted' ? (!window.I18n ? '' : window.I18n.t('members_page.components.actions.actions_panel.undelete')) : (!window.I18n ? '' : window.I18n.t('buttons.delete')) }</span></a></div> }</div></div>
  }
}

ActionsPanel.propTypes = {
  onChange: PropTypes.func.isRequired,
  member: PropTypes.object.isRequired,
  canOpenMemberModal: PropTypes.bool.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  deleteMember: PropTypes.func.isRequired,
  resetPasswordMember: PropTypes.func.isRequired,
  openRegisterMemberPopup: PropTypes.func.isRequired,
  getRegisterMemberData: PropTypes.func.isRequired,
  unregisterMember: PropTypes.func.isRequired,
  confirmMember: PropTypes.func.isRequired,
  canUseMasterRosterRegistration: PropTypes.bool.isRequired,
  customerSoftDelete: PropTypes.bool.isRequired,
  openEditMemberModal: PropTypes.func.isRequired,
  leagueProduct: PropTypes.string.isRequired,
  isGcatCustomer: PropTypes.bool.isRequired,
  hasMrSyncEnabled: PropTypes.bool.isRequired,
}

export default ActionsPanel
